<template>
  <Grid class="providers-table body bg-white-1 q-pl-md q-pr-lg q-py-lg">
    <AgGrid
      ref="agGrid"
      :header-height="48"
      :options="gridOptions"
      :api-request="infiniteScrollRequest"
      class="q-px-sm"
      style="grid-template-rows: 1fr"
      @ready="onGridReady"
      @export-loading="setExportLoading"
    >
    </AgGrid>
  </Grid>
</template>

<script>
import * as apiTo from '@/modular-api'
// Mixins
import { exportToExcel } from '@/mixins/export-to-excel'
import gridOptionsMixin from './gridOptions'
// Libraries
import { mapState, mapMutations } from 'vuex'
// Components
import AgGrid from '@/ag-grid/AgGrid'

export default {
  components: {
    AgGrid
  },

  mixins: [exportToExcel, gridOptionsMixin],

  props: {
    isVendor: Boolean
  },

  data: () => ({
    agGrid: null
  }),

  computed: {
    ...mapState('lv-providers', ['tableState']),

    metadataColumns() {
      if (this.isVendor) return this.$store.state.vendors.metaDataColumns
      return this.$store.state.publishers.metaDataColumns
    }
  },

  beforeDestroy() {
    this.storeTableState()
    this.$store.dispatch('lv-providers/saveTableState', this.isVendor ? 'vendors' : 'publishers')
  },

  methods: {
    ...mapMutations('lv-providers', ['setExportLoading']),

    infiniteScrollRequest(request) {
      if (this.isVendor) return apiTo.GET_PAGINATED_VENDORS(request)
      return apiTo.GET_PAGINATED_PUBLISHERS(request)
    },

    onGridReady(agGrid) {
      this.agGrid = agGrid
      this.$emit('ag-grid', agGrid)
      this.tableState.filter && this.agGrid.api.setFilterModel(this.tableState.filter)
      this.tableState.columns && this.agGrid.columnApi.setColumnState(this.tableState.columns)
    },

    storeTableState() {
      const filterModel = this.agGrid.api.getFilterModel()
      const columnState = this.agGrid.columnApi.getColumnState()

      this.$store.commit('lv-providers/setTableStateFilter', filterModel)
      this.$store.commit('lv-providers/setTableStateColumns', columnState)
    },

    exportToExcel() {
      this.mixinExportToExcel(this.$refs.agGrid.getGridOptions(), [], this.isVendor ? 'vendors' : 'publishers')
    }
  }
}
</script>
